import React from "react";
import { Avatar as AntAvatar } from "antd";
import "./style.scss";
import Loader from "../Loader";
import dummyUser from "assets/images/png/default-user.png";
const Avatar = ({
  url,
  size = 32,
  className = "",
  icon,
  text = "",
  isLoading,
  onClick,
}) => {
  const isJSX = React.isValidElement(icon);
  const showText = !url && !icon && text;

  const getDisplayText = () => {
    if (!showText) return null;
    const trimmed = text.trim();
    const firstWord = trimmed.split(/\s+/)[0];
    return firstWord[0].toUpperCase();
  };

  return (
    <Loader
      spinning={isLoading}
      style={{
        height: size,
        width: size,
      }}
    >
      <AntAvatar
        className={className}
        onClick={onClick}
        size={size}
        src={url || dummyUser}
        icon={icon ? (isJSX ? icon : React.createElement(icon)) : null}
      >
        {getDisplayText()}
      </AntAvatar>
    </Loader>
  );
};

export default Avatar;
